import { CardSubWrapper, CardWrapper } from 'admin/components/wrappers';
import BackNoCell from 'app/components/CustomDataGrid/Cells/BackNoCell';
import DivisionCell from 'app/components/CustomDataGrid/Cells/DivisionCell';
import GradeCell from 'app/components/CustomDataGrid/Cells/GradeCell';
import RiderNameCell from 'app/components/CustomDataGrid/Cells/RiderName';
import RiderStatus from 'app/components/CustomDataGrid/Cells/RiderStatusCell/RiderStatus';
import SIFamountPaidCell from 'app/components/CustomDataGrid/Cells/SifAmountPaid';
import TeamCell from 'app/components/CustomDataGrid/Cells/TeamCell';
import CustomDataGrid from 'app/components/CustomDataGrid/Index';
import { CustomDeletePopup } from 'app/components/CustomDeletePopup';
import React, { useState } from 'react';
import { ActiveRiderWrapper } from 'services/openapi';
import styled from 'styled-components';
import { GeneralLookup } from 'services/openapi';
import { useNavigateToRoute } from 'utils/common';
import { useLocation } from 'react-router-dom';
import { SortDescriptor } from '@progress/kendo-data-query';
import { GridSortChangeEvent } from '@progress/kendo-react-grid';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import HorizontalKebabCell from 'app/components/CustomDataGrid/Cells/HorizontalKebabCell';
import { usePermission } from 'hooks/usePermission';
import Cookies from 'js-cookie';

type Props = {
  activeRiderList: ActiveRiderWrapper | undefined;
  setPageSkip: React.Dispatch<React.SetStateAction<number | undefined>>;
  pageSkip: number | undefined;
  fetchActiveRiderList: (
    season?: string | undefined,
    teamFilter?: string[] | undefined,
    divisionFilter?: string[] | undefined,
    categoryFilter?: string[] | undefined,
    searchInput?: string | undefined,
    status?: string | undefined,
    sortBy?: string | undefined,
    sortOrder?: number | undefined,
    pageNumber?: number,
    pageSize?: number,
    paidFilter?: number,
  ) => void;
  debounceRiderSearch: string;
  deleteRiderInfo: (
    id?: string | undefined,
    season?: string | undefined,
    teamFilter?: string[] | undefined,
    divisionFilter?: string[] | undefined,
    categoryFilter?: string[] | undefined,
    searchInput?: string | undefined,
    status?: string | undefined,
    sortBy?: string | undefined,
    sortOrder?: number | undefined,
    pageNumber?: number,
    pageSize?: number,
  ) => void;
  selectedItemId: string | null;
  fetchRiderActiveOrInactive: (
    id: string,
    season?: string | undefined,
    activeStatusId?: string | undefined,
    searchInput?: string | undefined,
    status?: string | undefined,
    sortBy?: string | undefined,
    sortOrder?: number | undefined,
    pageNumber?: number,
    pageSize?: number,
    item?: string,
    teamId?: string[],
    divisionId?: string[],
  ) => void;
  lookup: GeneralLookup[];
  teamId: string[];
  divisionId: string[];
  categoryId: string[];
  sortField: string | undefined;
  sortOrder: number | undefined;
  setSortField: React.Dispatch<React.SetStateAction<string>>;
  setSortOrder: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  paidFilter?: number | null;
  pageSize: number;
  pageSizeSelected: GeneralLookup;
};

const RidersTable = ({
  activeRiderList,
  setPageSkip,
  pageSkip,
  fetchActiveRiderList,
  debounceRiderSearch,
  deleteRiderInfo,
  selectedItemId,
  fetchRiderActiveOrInactive,
  lookup,
  teamId,
  divisionId,
  categoryId,
  sortField,
  sortOrder,
  setSortField,
  setSortOrder,
  loading,
  paidFilter,
  pageSize,
  pageSizeSelected
}: Props) => {
  const userType = Cookies.get('userType') ?? '';
  const { hasViewPermission } = usePermission();
  const [showDeletePopup, setShowDeletePopup] = React.useState<boolean>(false);
  const [riderInfoId, setRiderInfoID] = useState('');
  const handleRowClick = () => { };
  const redirect = useNavigateToRoute();
  const activeId = lookup.find(item => item.name === 'Active');
  const inActiveId = lookup.find(item => item.name === 'Inactive');
  const currentLocation = useLocation();
  const isPastDataFlag = currentLocation.pathname.includes('past-data');
  const initialSort: Array<SortDescriptor> = [{ field: 'name', dir: 'asc' }];
  const [sort, setSort] = React.useState(initialSort);
  const handleMoreClick = (item: string, e) => {
    const id = e.dataItem.id;
    if (item === 'Make active') {
      if (hasViewPermission('0300101007')) {
        fetchRiderActiveOrInactive(
          id,
          e.dataItem.season?.id,
          activeId?.id,
          debounceRiderSearch,
          selectedItemId ?? '',
          sortField,
          sortOrder,
          pageSkip,
          10,
          item,
          teamId,
          divisionId,
        );
      }
    } else if (item === 'Make inactive') {
      if (hasViewPermission('0300101007')) {
        fetchRiderActiveOrInactive(
          id,
          e.dataItem.season?.id,
          inActiveId?.id,
          debounceRiderSearch,
          selectedItemId ?? '',
          sortField,
          sortOrder,
          pageSkip,
          10,
          item,
          teamId,
          divisionId,
        );
      }
    } else if (item === 'Delete rider') {
      if (hasViewPermission('0300101008')) {
        setRiderInfoID(e.dataItem.id);
        setShowDeletePopup(true);
      }
    } else if (item === 'Edit rider info') {
      if (hasViewPermission('0300101006')) {
        redirect(
          userType === 'COACH'
            ? `/coach/riders/${'edit'}/${e.dataItem.id}`
            : `/admin/riders/${'edit'}/${e.dataItem.id}`,
        );
      }
    }
  };
  const handleViewClick = e => {
    if (isPastDataFlag) {
      redirect(`/admin/past-data/riders/${`view`}/profile-info/${e?.id}`);
    } else {
      if (hasViewPermission('0300101003')) {
        redirect(
          userType === 'COACH'
            ? `/coach/riders/${`view`}/profile-info/${e?.id}`
            : `/admin/riders/${`view`}/profile-info/${e?.id}`,
        );
      }
    }
  };

  const rowRender = (trElement, props) => {
    const { dataItem } = props;
    const defaultRow = React.cloneElement(trElement, {});

    const isActive = dataItem?.status?.name === 'Active';
    if (dataItem.moveUpFlag && isActive) {
      const flagRow = (
        <FlagRow className="flag-row">
          <FlagCell className="flag-cell" colSpan={RiderColumn.length}>
            <FlagContent>
              <FlagIcon
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M14.778 3.222c-.342-.342-.805-.528-1.292-.528H6.5l-.5-1H3a1 1 0 0 0-1 1v11.5a.5.5 0 0 0 1 0V9h2.5l.5 1h6.986c.487 0 .95-.186 1.292-.528l1.293-1.293a1 1 0 0 0 0-1.414L14.778 3.222z" />
              </FlagIcon>
              {dataItem.moveUpFlag}
            </FlagContent>
          </FlagCell>
        </FlagRow>
      );
      return (
        <>
          {defaultRow}
          {flagRow}
        </>
      );
    }
    return defaultRow;
  };

  const RiderColumn = [
    {
      field: 'action',
      title: 'Action',
      cell: e => (
        <HorizontalKebabCell
          isAssigned={true}
          e={e}
          onMoreClick={handleMoreClick}
          isRider={true}
          isPastDataFlag={isPastDataFlag}
        />
      ),
      width: `${isPastDataFlag ? '0' : '100'}`,
      sortable: false,
    },
    {
      field: 'ridername',
      title: 'Rider Name',
      cell: e => <RiderNameCell e={e} onViewClick={e => handleViewClick(e)} />,
      width: '320',
      locked: true,
      sortable: true,
      className: 'rider-name-style',
      headerClassName: 'rider-header-style',
    },
    {
      field: 'backNumber',
      title: 'Back No:#',
      cell: e => <BackNoCell e={e} onClick={handleRowClick} />,
      width: '100',
      sortable: false,
    },

    {
      field: 'divisionOrClasses',
      title: 'Division/Classes',
      cell: e => <DivisionCell e={e} onClick={handleRowClick} />,
      width: '160',
      sortable: false,
    },
    {
      field: 'grade',
      title: 'Grade',
      cell: e => <GradeCell e={e} onClick={handleRowClick} />,
      width: '80',
      sortable: false,
    },
    {
      field: 'team',
      title: 'Team',
      cell: e => (
        <TeamCell e={e} onClick={handleRowClick} className="team-cell" />
      ),
      width: '180',
      sortable: true,
      headerClassName: 'team-header-style',
    },
    // {
    //   field: 'sifJoinDate',
    //   title: 'SIF join Date',
    //   cell: e => <SIFjoinDateCell e={e} />,
    //   width: '150',
    //   sortable: true,
    //   headerClassName: 'sif-join-header-style',
    // },
    {
      field: 'financialRespSignature',
      title: 'SIF Amt. Paid ',
      cell: e => <SIFamountPaidCell e={e} />,
      width: '140',
      sortable: false,
    },
    // {
    //   field: 'financialRespSignature',
    //   title: 'SIF Points ',
    //   cell: e => <SifPointCell e={e} />,
    //   width: '100',
    //   sortable: false,
    // },
    // {
    //   field: 'isPaymentComplete',
    //   title: 'Payment Completed',
    //   cell: e => <PaymentStatusCell e={e} />,
    //   width: '150',
    //   sortable: false,
    // },
    {
      field: 'teamStatus',
      title: 'Status',
      cell: e => <RiderStatus e={e} />,
      width: isPastDataFlag ? '100' : '150',
      sortable: false,
    },
  ];

  const handlePageChange = event => {
    setPageSkip(event.page.skip);
    fetchActiveRiderList(
      '',
      teamId,
      divisionId,
      categoryId,
      debounceRiderSearch,
      selectedItemId ?? '',
      sortField,
      sortOrder,
      event.page.skip,
      pageSize,
      paidFilter as number,
    );
  };

  const handleDeleteRiderInfo = () => {
    const currentItemCount = activeRiderList?.riders?.length ?? 0;

    // Calculate next page skip if we're deleting the last item on this page
    let nextPageSkip = pageSkip;
    if (currentItemCount <= 1 && pageSkip && pageSkip > 0) {
      nextPageSkip = pageSkip - pageSize;
      setPageSkip(nextPageSkip);
    }

    deleteRiderInfo(
      riderInfoId,
      '',
      teamId,
      divisionId,
      categoryId,
      debounceRiderSearch,
      selectedItemId ?? '',
      sortField,
      sortOrder,
      nextPageSkip ?? 0,
      pageSize,
    );
    setShowDeletePopup(false);
  };
  const handleSortChange = e => {
    let sortOrderValue = e.dir === 'asc' ? 0 : 1;
    setSortOrder(sortOrderValue);
    setSortField(e.field);
    fetchActiveRiderList(
      '',
      teamId,
      divisionId,
      categoryId,
      debounceRiderSearch,
      selectedItemId ?? '',
      e.field,
      sortOrderValue,
      pageSkip,
      pageSize,
      paidFilter as number,
    );
  };

  // Reset pagination when pageSize changes
  React.useEffect(() => {
    setSort([{ field: 'name', dir: 'asc' }]);
  }, [pageSize]);

  return (
    <>
      {loading ? (
        <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
      ) : (
        <CardWrapper style={{ paddingTop: '15px' }}>
          <CardSubWrapper className="d-flex"></CardSubWrapper>
          <GridWrapper>
            <CustomDataGrid
              showPagination={(activeRiderList?.pageDetails?.count ?? 0) > Number(pageSizeSelected.id)}
              data={activeRiderList?.riders ?? []}
              columns={RiderColumn}
              pageSize={pageSize}
              totalCount={activeRiderList?.pageDetails?.count}
              onPageChange={event => {
                handlePageChange(event);
              }}
              skip={pageSkip}
              sortable={{
                allowUnsort: false,
                mode: 'single',
              }}
              sort={sort}
              onSortChange={(e: GridSortChangeEvent) => {
                let sortvalue = e.sort[0];
                setSort(e.sort);
                handleSortChange(sortvalue);
              }}
              rowRender={rowRender}
            />
            <CustomDeletePopup
              deleteIcon={true}
              headerUnderline={false}
              popupSubLabel="Are you sure you want to delete this rider?"
              className="body-scroll-lock height-full delete-update"
              popupLabel="Delete rider"
              setVisible={setShowDeletePopup}
              visible={showDeletePopup}
              align="centre"
              btnLabel1="Cancel"
              btnLabel2="Delete"
              handlebtn2Click={handleDeleteRiderInfo}
              handlebtn1Click={() => {
                setShowDeletePopup(false);
              }}
            />
          </GridWrapper>
        </CardWrapper>
      )}
    </>
  );
};

export default RidersTable;

const GridWrapper = styled.div`
  .k-grid-container {
    height: calc(100vh - 300px);
  }

  .k-grid .flag-row .flag-cell {
    background-color: #e4e1c3 !important;
    color: #e91515 !important;
    font-weight: 500;
    padding: 8px 12px;
  }

  .k-grid-content tr td.team-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
  .k-grid-content tr .rider-name-style {
    .name-label,
    .sub-name-label {
      cursor: pointer !important;
    }
  }
  .k-table-thead {
    .k-link {
      cursor: default;
    }
    .sif-join-header-style,
    .team-header-style,
    .rider-header-style {
      cursor: pointer !important;
      .k-link {
        cursor: pointer !important;
      }
    }
  }
`;

const FlagRow = styled.tr``;

const FlagCell = styled.td`
  background-color: #e4e1c3 !important;
  color: #e91515 !important;
  font-weight: 500;
  padding: 8px 12px;
`;

const FlagIcon = styled.svg`
  flex-shrink: 0;
`;

const FlagContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
`;
